import { uniqBy } from 'es-toolkit'

export function mergeOptions<T extends { value: string | number }>(...groups: readonly T[][]): T[] {
  return uniqBy(groups.flat(), (option) => option.value)
}

export function mergeNumberOptions<
  TCurrent extends { label: string; value: number },
  TOption extends { label: string; value: number }
>(current: TCurrent | undefined, options: TOption[]): (TCurrent | TOption)[] {
  return mergeOptions<TCurrent | TOption>(current ? [current] : [], options)
}
